import type { SimEvent } from "../sim";

/** Звук события: имя рецепта (audio/library.ts) и громкость 0..1. */
export interface Cue {
  readonly name: string;
  readonly gain: number;
}

/** Удар по силе: лёгкий, средний, тяжёлый (сила события 0, 1, 2). */
const HIT_BY_STRENGTH = ["hit-light", "hit-medium", "hit-heavy"] as const;

/**
 * Какие звуки у события мира (консультант 05.11.2026: «удары по силе, блок, шаги, нокаут, глухой звук и сердце в
 * замедлении»): попадание — по силе (или свой звук приёма), блок, начало приёма — свист замаха (или свой: скачок,
 * невидимка), удар о пол, нокаут, суперприём, начало замедления решающего удара.
 */
export function cuesFor(event: SimEvent): Cue[] {
  switch (event.kind) {
    case "hit": {
      const byStrength = HIT_BY_STRENGTH[Math.max(0, Math.min(2, event.strength))] ?? "hit-light";
      return [{ name: event.sound ?? byStrength, gain: 0.8 + 0.1 * event.strength }];
    }
    case "block":
      return [{ name: "block", gain: 0.8 }];
    case "ability":
      if (event.ability?.startsWith("taunt")) return [];
      return [{ name: event.sound ?? "whoosh", gain: event.sound ? 0.8 : 0.45 }];
    case "land":
      return [{ name: event.strength >= 2 ? "land" : "step", gain: event.strength >= 2 ? 0.9 : 0.5 }];
    case "ko":
      return [{ name: "ko", gain: 1 }];
    case "superStart":
      return [{ name: "super", gain: 0.9 }];
    case "superHit":
      return [{ name: "hit-heavy", gain: 0.9 }];
    case "superFinale":
      return [{ name: "ko", gain: 0.9 }];
    case "action":
      return event.fx === "decisive/start" ? [{ name: "slowmo", gain: 1 }] : [];
    default:
      return [];
  }
}
